/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";

import UserProfile from "views/UserProfile.js";

import Temuan from "views/Temuan";

import TindakLanjutTemuan from "views/TindakLanjutTemuan";

import UsersSoiSalak from "views/UsersSoiSalak";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/temuan",
    name: "Temuan",
    rtlName: "الرموز",
    icon: "tim-icons icon-bullet-list-67",
    component: Temuan,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/tindak-lanjut-temuan",
    name: "Tindak Lanjut Temuan",
    rtlName: "الرموز",
    icon: "tim-icons icon-pencil",
    component: TindakLanjutTemuan,
    layout: "/admin",
    sidebar: true,
    user: true,
  },

  {
    path: "/users-soisalak",
    name: "Users Soi Salak",
    rtlName: "ملف تفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: UsersSoiSalak,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تفي للمستخدم",
    icon: "tim-icons icon-badge",
    component: UserProfile,
    layout: "/admin",
    sidebar: true,
    user: true,
  },
];
export default routes;
